
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Comprehensive logging for deployment troubleshooting
console.log("Starting application");
console.log("Window location:", window.location.href);
console.log("Window origin:", window.location.origin);
console.log("Window pathname:", window.location.pathname);
console.log("Running in environment:", process.env.NODE_ENV);
console.log("User Agent:", navigator.userAgent);

// Test network connectivity
fetch(`${window.location.origin}/favicon.ico?cache=${Date.now()}`)
  .then(res => console.log("Favicon fetch test:", res.status))
  .catch(err => console.error("Favicon fetch test failed:", err));

// Test if base element exists and log its value
const baseElement = document.querySelector('base');
console.log("Base element:", baseElement ? baseElement.href : "not found");

const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error("Root element not found - this is critical");
  throw new Error("Root element not found");
}

// Render immediately without waiting for DOMContentLoaded
try {
  const root = createRoot(rootElement);
  console.log("Rendering app to root element");
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log("App rendered successfully");
} catch (error) {
  console.error("Failed to render app:", error);
}
